import buyer from './buyer.json';
import research from './research.json';
import signIn from './signin.json';
import signUp from './signup.json';
import saved from './saved.json';
import seller from './seller.json';
import user from './user.json';
import { Navigation } from '../../types';

const defaultNavigation: Navigation = [
  buyer,
  {
    ...seller,
    name: `${seller?.name}-mobile`,
    type: 'link',
    condition: {
      ...seller?.condition,
      mediaQuery: '!medium'
    }
  },
  research,
  saved,
  signIn,
  signUp,
  user,
  seller
];

export default defaultNavigation;
